import Styles from './CardBack.module.scss'
import { CSSProperties, forwardRef } from 'react'
import { CardProps } from 'components/SecretIdentity/Types'
import { heroImagesBack } from 'components/SecretIdentityModal/identities'
import cx from 'classnames'

export const CardBack = forwardRef<HTMLDivElement, CardProps>(({ imageKey, isSelected }, ref) => (
  <div
    className={cx(Styles.root, { [Styles.isSelected]: isSelected })}
    ref={ref}
    style={
      {
        '--image': `url(${heroImagesBack[imageKey]})`,
      } as CSSProperties
    }
  >
    <div className={Styles.content} />
  </div>
))
